import { TaskList } from '@features/admin/tasks/TaskList';
import { usePageTitle } from '@shared/hooks/usePageTitle';

export const TasksPage = () => {
  usePageTitle('Admin tasks');

  return <TaskList />;
};
